__turbopack_context__.v({
  "avatar": "TeamAvatars-module-scss-module__CeKFbW__avatar",
  "avatarImage": "TeamAvatars-module-scss-module__CeKFbW__avatarImage",
  "avatarsContainer": "TeamAvatars-module-scss-module__CeKFbW__avatarsContainer",
  "blue": "TeamAvatars-module-scss-module__CeKFbW__blue",
  "gray": "TeamAvatars-module-scss-module__CeKFbW__gray",
  "green": "TeamAvatars-module-scss-module__CeKFbW__green",
  "orange": "TeamAvatars-module-scss-module__CeKFbW__orange",
  "pink": "TeamAvatars-module-scss-module__CeKFbW__pink",
});
